import { Component, OnInit } from '@angular/core';
import { tabs } from 'src/app/dummy/tabs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddSessionComponent } from '../add-session/add-session.component';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.scss']
})
export class SessionComponent implements OnInit {
  tabs = tabs.SHIFT
  
  constructor(
    private router: Router,
    public store: List,
    private ds:DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddSessionComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.sessionRef())
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
